import { ConfigModule, CmsConfig, I18nModule } from '@spartacus/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrOrderFormSearchComponent } from './kn-br-order-form-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        FormsModule,
        ReactiveFormsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrSearchProductComponent: {
                    component: KnBrOrderFormSearchComponent,
                },
            },
        } as CmsConfig),
        KnBrOrderFormSearchComponent,
    ],
})
export class KnBrOrderFormSearchModule {}
